import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateVehiculo } from '../../helpers/api_helper';

const useUpdateVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const updateVehiculoHook = async (PATENT, datosVehiculo) => {
        setLoading(true);
        setError(null);
        try {
            // Transform data to match backend expectations
            const transformedData = {
                MARCAS: datosVehiculo.marca?.value || null,
                MODELO: datosVehiculo.modelo?.value || null,
                ANOFAB: datosVehiculo.ano ? parseInt(datosVehiculo.ano, 10) : null,
                CCOLOR: datosVehiculo.color?.value || null,
                NMOTOR: datosVehiculo.motor || null,
                NCHASI: datosVehiculo.chasis || null,
                NROVIN: datosVehiculo.vin || null,
                TRACCI: datosVehiculo.tipoTraccion?.value || null,
                TRASMI: datosVehiculo.tipoTransmision?.value || null,
                COMBUS: datosVehiculo.tipoCombustible?.value || null,
                CLIENT: datosVehiculo.rut || null
            };
            const params = { tenantId, empresa, departamento };
            const response = await updateVehiculo(
                empresa,
                PATENT,
                { vehicleData: transformedData, usuario: userInfo?.name },
                params
            );
            if (response) {
                return { success: true };
            } else {
                throw new Error(response.message || 'Error al actualizar el vehículo');
            }
        } catch (err) {
            const errorMessage = `Failed to update vehiculo: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateVehiculo: updateVehiculoHook, loading, error };
};

export default useUpdateVehiculo;
